"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerDependencies = registerDependencies;
exports.registerModule = registerModule;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _forIn = _interopRequireDefault(require("lodash/forIn"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isObjectLike = _interopRequireDefault(require("lodash/isObjectLike"));

var _reducers = require("./store/reducers");

var _excluded = ["moduleName", "di", "store", "reducer", "Api", "HubConnection", "WebSockets"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function registerDependencies(di, components) {
  var moduleName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  (0, _forIn["default"])(components, function (dependencyKwargs, name) {
    var dependencyName = "".concat(moduleName).concat(name);

    if ((0, _isObjectLike["default"])(dependencyKwargs) && moduleName) {
      var method = dependencyKwargs.method,
          dependency = dependencyKwargs.dependency;

      if ((0, _isUndefined["default"])(dependency)) {
        throw new Error("Dependency is undefined. Register package or dependency (".concat(dependencyName, ") in src/dependencies.js."));
      }

      di[method](dependencyName, dependency);
    } else {
      di.value(dependencyName, dependencyKwargs);
    }
  });
}

function registerModule(_ref) {
  var moduleName = _ref.moduleName,
      di = _ref.di,
      store = _ref.store,
      reducer = _ref.reducer,
      Api = _ref.Api,
      HubConnection = _ref.HubConnection,
      WebSockets = _ref.WebSockets,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (reducer) {
    (0, _reducers.injectReducer)(store, {
      key: moduleName,
      reducer: reducer
    });
  }

  if (Api) {
    var ApiClass = Api.Api,
        url = Api.url,
        params = Api.params;
    registerDependencies(di, {
      api: {
        dependency: function dependency() {
          return new ApiClass(di.container, moduleName, _objectSpread({
            baseURL: url
          }, params));
        },
        method: 'service'
      }
    }, "".concat(moduleName, "."));
  }

  if (HubConnection) {
    var HubConnectionClass = HubConnection.HubConnection,
        _url = HubConnection.url,
        _params = HubConnection.params;
    registerDependencies(di, {
      hubConnection: {
        dependency: function dependency() {
          return new HubConnectionClass(_objectSpread({
            baseURL: _url
          }, _params));
        },
        method: 'service'
      }
    }, "".concat(moduleName, "."));
  }

  if (WebSockets && WebSockets.length) {
    WebSockets.forEach(function (_ref2) {
      var WebSocket = _ref2.WebSocket,
          options = _ref2.options,
          socketName = _ref2.socketName;
      return registerDependencies(di, (0, _defineProperty2["default"])({}, socketName, {
        dependency: function dependency() {
          return new WebSocket(options);
        },
        method: 'service'
      }), "".concat(moduleName, "."));
    });
  }

  if (rest) {
    registerDependencies(di, {
      properties: {
        dependency: function dependency() {
          return rest;
        },
        method: 'service'
      }
    }, "".concat(moduleName, "."));
  }
}